/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'
import chevronUrl from 'img/icon/chevron.svg'

const StyledTextWithUsps = styled.section`
  position: relative;
  z-index: 1;

  @media screen and (min-width: 992px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  @media screen and (max-width: 991px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const StyledBox = styled.div`
  background-color: ${(props) => props.theme.color.face.light};
  height: 100%;
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  padding: 60px;

  @media screen and (max-width: 991px) {
    padding: 40px 24px;
  }
`

const StyleShadow = styled.div`
  background: ${(props) => props.theme.color.gradient.main};
  position: absolute;
  height: 100%;
  width: 100%;
  top: -40px;
  left: -40px;
  z-index: -1;
  border-radius: 20px;

  @media screen and (max-width: 991px) {
    top: -10px;
    left: -10px;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 60px;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    gap: 30px;
  }
`

const TextColumn = styled.div`
  position: relative;
  flex-shrink: 0;

  @media screen and (min-width: 992px) {
    width: 50%;
  }

  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`

const UspsColumn = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  @media screen and (min-width: 992px) {
    width: 50%;
  }

  & ul {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
  }

  & ul li {
    font-weight: ${(props) => props.theme.font.weight.xl};
    
    @media screen and (min-width: 992px) {
      margin: 28px 0;
    }

    @media screen and (max-width: 991px) {
      margin: 10px 0;
    }
  }

  & ul li,
  & p {
    font-size: ${(props) => props.theme.font.size.xm};
    line-height: 1.5;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      width: 24px;
      height: 24px;
      background: ${(props) => props.theme.color.gradient.main};
      -webkit-mask: url(${chevronUrl}) no-repeat center;
      mask: url(${chevronUrl}) no-repeat center;
      -webkit-mask-size: contain;
      mask-size: contain;
    }
  }
`

const TextWithUsps = ({ className = '', content, id = 'text-with-usps' }) => {
  if (!content) return null
  return (
    <StyledTextWithUsps id={id} className={`${className}`}>
      <StyledContainer className="container">
        <Wrapper>
          <TextColumn>
            <StyledBox>
              <h2>{content?.title}</h2>
              <ParseContent
                content={content?.description}
                compactLineHeight
              />
            </StyledBox>
            <StyleShadow />
          </TextColumn>
          <UspsColumn>
            <ParseContent content={content?.usp} />
          </UspsColumn>
        </Wrapper>
      </StyledContainer>
    </StyledTextWithUsps>
  )
}

export default TextWithUsps
